<script>
import { Line } from "vue-chartjs";
import ChartJs from "chart.js";


export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    handleClick: Function,
    legendData: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      localChartData: null
    };
  },
  mounted () {
    this.localChartData = JSON.parse(JSON.stringify(this.chartdata));

    this.legendData.forEach((hidden,i)=>{
         this.localChartData.datasets[i].hidden = hidden;
     });

    const vm = this;
    this.renderChart(this.localChartData, {...this.options, legend: { onClick(event, legendItem) {
      vm.handleClick(legendItem.datasetIndex);
      ChartJs.defaults.global.legend.onClick.call(this, event, legendItem)
    }}});
  },
  updated () {
    this.renderChart(this.chartdata, this.options)
  }
};
</script>
